import Text from "@/components/common/Text"
import React from "react"
import styled from "styled-components"
import { getCssSizeValue, getPaddingsClassFromData, getPropSafely } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { insetGapLeftCss } from "@/styles/globalStyles"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"
import GridContainer from "@/components/common/GridContainer"
import ShareButton from "@/components/common/ShareButton"
import { ICONS } from "@/constants"
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share"

const ContentWrapper = styled.div`
	background: ${({ theme }) => theme.colors.platinum};
	display: flex;
	flex-direction: column;
	gap: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	padding: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)} ${getCssSizeValue(48, BREAKPOINTS.MOBILE)}
		${getCssSizeValue(32, BREAKPOINTS.MOBILE)} ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding: ${getCssSizeValue(24, BREAKPOINTS.TABLET)} ${getCssSizeValue(32, BREAKPOINTS.TABLET)}
			${getCssSizeValue(24, BREAKPOINTS.TABLET)} ${getCssSizeValue(54, BREAKPOINTS.TABLET)};
		align-items: center;
		flex-direction: row;
		gap: ${getCssSizeValue(100, BREAKPOINTS.TABLET)};
		justify-content: space-between;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		${insetGapLeftCss};
		padding: ${getCssSizeValue(48)} ${getCssSizeValue(72)} ${getCssSizeValue(48)} ${getCssSizeValue(56)};
		gap: unset;
	}
`

const HeaderAndDescription = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		gap: ${getCssSizeValue(8, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		gap: ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)};
	}

	.header {
		position: relative;
		font-weight: 900;

		&:before {
			--size: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};
			position: absolute;
			content: "";
			top: 12px;
			translate: 0 -50%;
			left: ${getCssSizeValue(-16)};
			width: var(--size);
			height: var(--size);
			background: ${({ theme }) => theme.colors.richBlack};

			@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
				--size: ${getCssSizeValue(8, BREAKPOINTS.TABLET)};
			}

			@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
				--size: ${getCssSizeValue(8)};
			}
		}
	}

	.description {
		font-weight: 500;
	}
`

const ShareButtons = styled.div`
	display: flex;
	justify-content: space-between;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		gap: ${getCssSizeValue(40, BREAKPOINTS.TABLET)};
		justify-content: flex-start;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		gap: ${getCssSizeValue(40)};
	}
`

const formatData = (data) => {
	return {
		paddings: getPaddingsClassFromData(data),
		headerDescription: getPropSafely(data, "headerDescription", null),
		shareTitle: getPropSafely(data, "shareTitle"),
		shareDescription: getPropSafely(data, "shareDescription"),
	}
}

function Share({ data }) {
	const { paddings, headerDescription, shareDescription, shareTitle } = formatData(data)

	return (
		<section className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<GridContainer className="indent-desktop-1">
				<ContentWrapper className="col-mobile-8 col-tablet-8 col-desktop-9">
					<HeaderAndDescription>
						<Text className="typo-strawford typo-strawford-93 header">{shareTitle}</Text>
						<Text className="typo-strawford typo-strawford-94 description">{shareDescription}</Text>
					</HeaderAndDescription>
					<ShareButtons>
						<ShareButton big iconName={ICONS.FACEBOOK} Provider={FacebookShareButton} />
						<ShareButton big iconName={ICONS.LINKEDIN} Provider={LinkedinShareButton} />
						<ShareButton big iconName={ICONS.TWITTER} Provider={TwitterShareButton} />
					</ShareButtons>
				</ContentWrapper>
			</GridContainer>
		</section>
	)
}

export default Share
